import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { WagmiProvider } from "wagmi";
import { PrivyProvider, type PrivyClientConfig } from "@privy-io/react-auth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@rainbow-me/rainbowkit/styles.css";
import "@/styles/index.css";
import { rainbowConfig, wagmiConfig } from "@/utils/wallet-connect";
import App from "@/root";

const queryClient = new QueryClient();
const privyAppId = import.meta.env.VITE_PRIVY_APP_ID;
const usePrivy = import.meta.env.VITE_USE_PRIVY === "true";

if (!privyAppId || privyAppId === "YOUR_PRIVY_APP_ID") {
  console.warn(
    "⚠️ VITE_PRIVY_APP_ID is optional. Rainbow Kit will be used as primary wallet connector.\n" +
    "To enable Privy fallback, get your App ID from https://dashboard.privy.io/",
  );
}

const privyConfig: PrivyClientConfig = {
  loginMethods: ["wallet", "email", "google", "twitter", "github"] as any[],
  appearance: {
    theme: "dark",
    accentColor: "#676FFF",
  },
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {!privyAppId || privyAppId === "YOUR_PRIVY_APP_ID" ? (
        <WagmiProvider config={rainbowConfig}>
          <RainbowKitProvider>
            <App />
          </RainbowKitProvider>
        </WagmiProvider>
      ) : usePrivy ? (
        <PrivyProvider appId={privyAppId} config={privyConfig}>
          <WagmiProvider config={rainbowConfig}>
            <RainbowKitProvider>
              <App />
            </RainbowKitProvider>
          </WagmiProvider>
        </PrivyProvider>
      ) : (
        <WagmiProvider config={rainbowConfig}>
          <RainbowKitProvider>
            <PrivyProvider appId={privyAppId} config={privyConfig}>
              <App />
            </PrivyProvider>
          </RainbowKitProvider>
        </WagmiProvider>
      )}
    </QueryClientProvider>
  </StrictMode>,
);
